import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { 
  Box,
} from '@mui/material';

import SideBarLogo from '../utils/SideBarLogo';
import ConfirmationModal from '../modals/ConfirmationModal';
import TopNavigation from './TopNavigation';
import SideNavigation from './SideNavigation';
import { DASIProvider } from '../../context/DASIContext';

import { LOG_OUT } from '../../redux/actionTypes';

import "./styles.scss";

const Navigation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(0);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const [isNavExpanded, setIsNavExpanded] = useState(JSON.parse(localStorage.getItem("navExpanded")));

  useEffect(() => {
    var route = location.pathname.split("/").slice(1);    
    route = route.join("/")

    switch(route){
      case "": return setCurrentPage(0);
      case "data-ingestion": return setCurrentPage(1);
      case "broker-resolution-desk": return setCurrentPage(2);
      
      default: return setCurrentPage(0);
    }

  }, [currentPage, location.pathname]);

  // ======================= Log out handler ============================
  const handleLogout = () => {
    dispatch({ type: LOG_OUT });
  }

  return (
    <DASIProvider>
    <Box className="nav">
      <ConfirmationModal 
        open={confirmationModalOpen}
        setOpen={setConfirmationModalOpen}
        title={"Log out"}
        onConfirm={handleLogout}
        />

      <Box display={"flex"}
        sx={{ 
          height: "100vh" }}>
        {
          location.pathname !== "/add-bank-account" && location.pathname !== "/add-subscription" && location.pathname !== "/unapproved"
          &&
          <SideBarLogo 
            isNavExpanded={isNavExpanded} />
        }
        {
          (location.pathname !== "/dashboard" && location.pathname !== "/profile" &&
            location.pathname !== "/add-bank-account" && location.pathname !== "/add-subscription" && location.pathname !== "/unapproved"
          )
          &&
          <SideNavigation
            currentPage={currentPage}
            isNavExpanded={isNavExpanded}
            setIsNavExpanded={setIsNavExpanded} />
        }
        <Box
          display={"flex"}
          flexDirection={"column"}
          sx={{
            height: "calc(100vh - 0px)",
            width: "100%"
          }}>
          {
            location.pathname !== "/add-bank-account" && location.pathname !== "/add-subscription" && location.pathname !== "/unapproved"
            &&
            <TopNavigation />
          }
          <Box 
            padding={"10px 30px 0px 30px"}
            sx={{
            height: "100%",
            backgroundColor: "white",
            margin: "0px 10px 10px 10px",
            borderRadius: "16px",
            overflow: "auto",
            // boxShadow: "rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px",
            }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
    </DASIProvider>
  )
}

export default Navigation;